import type {
  CreateUpstreamAccountRequest,
  CreateUpstreamAccountResponse,
  DeleteUpstreamAccountResponse,
  ListUpstreamAccountsResponse,
  UpdateUpstreamAccountRequest,
  UpdateUpstreamAccountResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listAccounts(
  upstreamId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<ListUpstreamAccountsResponse> {
  return opsApiRequest<ListUpstreamAccountsResponse>(
    `/v1/ops/upstreams/${upstreamId}/accounts`,
    { method: 'GET' },
    fetchImpl,
  );
}

export function createAccount(
  upstreamId: string,
  body: CreateUpstreamAccountRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<CreateUpstreamAccountResponse> {
  return opsApiRequest<CreateUpstreamAccountResponse>(
    `/v1/ops/upstreams/${upstreamId}/accounts`,
    {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
    },
    fetchImpl,
  );
}

export function updateAccount(
  upstreamId: string,
  accountId: string,
  body: UpdateUpstreamAccountRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<UpdateUpstreamAccountResponse> {
  return opsApiRequest<UpdateUpstreamAccountResponse>(
    `/v1/ops/upstreams/${upstreamId}/accounts/${accountId}`,
    {
      method: 'PATCH',
      headers: { 'content-type': 'application/json' },
      body,
    },
    fetchImpl,
  );
}

export function deleteAccount(
  upstreamId: string,
  accountId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DeleteUpstreamAccountResponse> {
  return opsApiRequest<DeleteUpstreamAccountResponse>(
    `/v1/ops/upstreams/${upstreamId}/accounts/${accountId}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}
